var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLink = function SvgIcLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "cureentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#F7FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.86 18.173a7.874 7.874 0 0 0-11.135 0l-8.349 8.351A7.873 7.873 0 1 0 37.51 37.658l.988-.99s-.444-1.25-.988-1.793c-.543-.545-1.795-.99-1.795-.99l-.988.99a3.937 3.937 0 1 1-5.568-5.568l8.351-8.35a3.936 3.936 0 1 1 5.566 5.567l-1.391 1.392s.964.626 1.57 1.234c.61.608 1.213 1.549 1.213 1.549l1.391-1.392a7.873 7.873 0 0 0 0-11.134Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.686 30.7a7.872 7.872 0 0 0-11.136 0l-1.065 1.066s.528 1.181 1.071 1.723c.543.543 1.712 1.06 1.712 1.06l1.065-1.066a3.938 3.938 0 1 1 5.568 5.568l-8.35 8.35a3.935 3.935 0 0 1-5.568 0 3.936 3.936 0 0 1 .001-5.567l1.533-1.534s-.99-.706-1.535-1.25c-.541-.543-1.25-1.533-1.25-1.533l-1.53 1.534a7.873 7.873 0 1 0 11.131 11.134l8.351-8.351a7.874 7.874 0 0 0 .002-11.134Z"
  })));
};
export default SvgIcLink;